import { Component, OnInit, Input } from '@angular/core';
import { SetService } from 'ngx-block-core';
import { FormGroup } from '@angular/forms';
import { FormControlService } from "ngx-block-core";
import { selectSize, dataMode, disabledHours, disabledMinutes } from "../../../data/data";
import { getDayOfYear, addDays } from 'date-fns';

@Component({
  selector: 'app-sucu04-weiget0040001',
  templateUrl: './sucu04-weiget0040001.component.html',
})
export class Sucu04Weiget0040001Component implements OnInit {
  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() form: FormGroup;
  @Input() nzFormGroupData;
  @Input() nzLayout = 'horizontal'

  @Input() sets = {
    blockCode: "sucublock23",
    blockId: "",
    blockName: "日期控件",
    layoutId: "",
    blockType: 'formBlock',
    blockChildType: '',
    versionCode: 7,
    attributes: ['form', 'nzFormGroupData', 'nzLayout'],
    events: [
      {
        label: "重置",
        value: "reset",
        data: { setParams: ["刷新 : true|false", '只刷新 : true|false', '备用'] }
      },
      {
        label: "可用不可用",
        value: "isable",
        data: {
          setParams: ["不可用值", '可用值', 'disable(强制不可用),enable(强制可用,不可用值不能为空),reset,disablevalue(例:disablevalue,1),enablevalue']
        }
      }
    ],
    styles: {
      nzMode: "date",//date|month|year|range|week
      nzReadOnly: false,
      nzAllowClear: true,
      nzFormat: {
        date: 'yyyy-MM-dd',
        month: 'yyyy-MM',
        year: 'yyyy',
        range: 'yyyy-MM-dd',
        week: 'yyyy-ww'
      },
      nzPlaceHolder: "请选择日期",
      nzPlaceHolders: ['开始日期', '结束日期'],
      nzRenderExtraFooter: "",
      nzShowToday: true,
      nzShowTime: {
        nzUsed: false,
        nzObject: false,
        nzFormat: {
          nzFormat: 'HH:mm:ss'
        },
      },
      nzSize: "default",


      nzLayout: {
        nzLayout1: 0,
        nzLayout2: 8,
        nzLayout3: 0,
        nzLayout4: 16,
        nzAlign: 'left',
        nzMarginBottom: 3,
        nzLineHeight: 1.4,
        nzFontSize: 12
      },
      nzRequired: false,
      nzHasFeedback: false,
      nzNoSee: false
    },
    datas: {
      nzSearchDataType: "date",
      nzSearchType: "=",
      nzToday: false,
      nzDefaultDate: 'none',
      nzDisabledTime: {
        nzDisabledHours: [],
        nzDisabledMinutes: [],
        nzDisabledSeconds: [],
      },
      nzDisabledDate: {
        range: {
          nzUsed: false,
          data: []
        },
        available: {
          nzUsed: false,
          nzType: 'today',
          today: {
            before: 15,
            after: 15
          },
          range: []
        },
        month: {
          nzUsed: false,
          data: []
        },
        week: {
          nzUsed: false,
          data: []
        }

      }
    }
  };
  setData = []

  constructor(
    public setService: SetService,
    private formControlService: FormControlService,

  ) { }
  ngOnInit() {
    this.baseInit();
    if (this.sets.styles.nzReadOnly) {
      console.log('disable', this.sets.blockName);
      this.form.get(this.nzFormGroupData.nzKey).disable();
    } else {
      console.log('enable', this.sets.blockName);
      this.form.get(this.nzFormGroupData.nzKey).enable();
    }
    this.today = new Date()
    this.todayday = getDayOfYear(this.today)

    this.autoUpdate();
    this.Listening();
    //默认日期
    if (this.sets.datas.nzDefaultDate !== 'none') {
      switch (this.sets.datas.nzDefaultDate) {
        case 'year':
          if (this.sets.styles.nzMode === 'range') {
            this.form.get(this.nzFormGroupData.nzKey).patchValue([addDays(this.today, -365), this.today]);
          }
          break;
        case 'halfyear':
          if (this.sets.styles.nzMode === 'range') {
            this.form.get(this.nzFormGroupData.nzKey).patchValue([addDays(this.today, -183), this.today]);
          }
          break;
        case 'halfmonth':
          if (this.sets.styles.nzMode === 'range') {
            this.form.get(this.nzFormGroupData.nzKey).patchValue([addDays(this.today, -14), this.today]);
          }
          break;
        case 'week':
          if (this.sets.styles.nzMode === 'range') {
            this.form.get(this.nzFormGroupData.nzKey).patchValue([addDays(this.today, -7), this.today]);
          }
          break;

        case 'today':
          if (this.sets.styles.nzMode === 'range') {
            this.form.get(this.nzFormGroupData.nzKey).patchValue([this.today, this.today]);
          } else {
            this.form.get(this.nzFormGroupData.nzKey).patchValue(this.today);
          }
          break;
        case 'month':
          if (this.sets.styles.nzMode === 'range') {
            this.form.get(this.nzFormGroupData.nzKey).patchValue([addDays(this.today, -30), this.today]);
          }
          break;

        default:
          break;
      }
    }
    // if (this.sets.datas.nzToday) {
    //   if (this.sets.styles.nzMode === 'range') {
    //     this.form.get(this.nzFormGroupData.nzKey).patchValue([this.today, this.today]);
    //   } else {
    //     this.form.get(this.nzFormGroupData.nzKey).patchValue(this.today);
    //   }
    // }
  }

  autoUpdate() {

    //v3,升级自定义表单参数
    if (this.sets.versionCode < 3) {

      this.sets.blockCode = "sucublock23";

      this.sets.versionCode = 3;
    }
    //v4,升级自定义表单参数
    if (this.sets.versionCode < 4) {
      if (typeof this.sets.styles.nzNoSee == "undefined")
        this.sets.styles.nzNoSee = false;
      this.sets.versionCode = 4;
    }
    if (this.sets.versionCode < 5) {
      this.sets.datas.nzToday = false;
      this.sets.versionCode = 5;
    }
    if (this.sets.versionCode < 6) {
      this.sets.datas.nzDefaultDate = 'none';
      this.sets.versionCode = 6;
    }
    if (this.sets.versionCode < 7) {
      this.sets.events = [
        {
          label: "重置",
          value: "reset",
          data: { setParams: ["刷新 : true|false", '只刷新 : true|false', '备用'] }
        },
        {
          label: "可用不可用",
          value: "isable",
          data: {
            setParams: ["不可用值", '可用值', 'disable(强制不可用),enable(强制可用,不可用值不能为空),reset,disablevalue(例:disablevalue,1),enablevalue']
          }
        }
      ],
        this.sets.versionCode = 7;
    }
  }

  today
  todayday
  Listening() {
    console.log("Listening-radio", this.blockid)
    setTimeout(() => {
      this.setService.initEvent(this.blockid);
      this.setService.events[this.blockid].subscribe(
        data => {
          console.log("data-radio", JSON.stringify(data))
          let array0 = [];
          let array1 = [], array2 = [];
          switch (data['type']) {
            case 'reset':
              this.form.get(this.nzFormGroupData.nzKey).patchValue(null)
              this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
              this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
              break;

            case 'isable':

              console.log("isable", data.datas)
              array0 = (data.datas.param0 + "").split(",");
              array1 = (data.datas.param1 + "").split(",");
              array2 = (data.datas.param2 + "").split(",");
              if (array0.indexOf(data.datas.value) >= 0 || array2.indexOf('disable') >= 0) {
                //disable
                console.log("isable", 'disable')
                this.form.get(this.nzFormGroupData.nzKey).disable();
                if (array2.indexOf('reset') >= 0) {
                  this.form.get(this.nzFormGroupData.nzKey).patchValue(null);
                  this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
                  this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
                }

              } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 === "" || array2.indexOf('enable') >= 0) {
                // enable
                console.log("isable", 'enable')
                this.form.get(this.nzFormGroupData.nzKey).enable();

              }

              break;


            default:
              break;
          }


        }
      )
    }, !this.static ? 100 : 0);


  }


  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormDataSource' },
              {
                name: 'nzFormSearchType',
                inputs: {
                  dateFormat: true, nzData: [{ value: 'like', label: '模糊查询(like)' }, { value: '=', label: '精确匹配(=)' }, { value: 'between', label: '范围(between)' }]
                }
              },
              // {
              //   name: 'switch',
              //   inputs: { nzText: "默认今天 : ", nzKeys: ['datas', 'nzToday'], nzPopContent: '建议只在搜索时使用' }
              // },

              {
                name: 'select',
                inputs: {
                  nzText: "默认策略 : ", nzKeys: ['datas', 'nzDefaultDate'],
                  nzData: [
                    { value: 'none', label: '无' },
                    { value: 'year', label: '一年' },
                    { value: 'halfyear', label: '半年' },
                    { value: 'month', label: '一月' },
                    { value: 'halfmonth', label: '半月' },
                    { value: 'week', label: '一周' },
                    { value: 'today', label: '今天' },
                  ]
                }
              },


            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'select',
                inputs: { nzText: "模式 : ", nzKeys: ['styles', 'nzMode'], nzData: dataMode },
                outputs: {
                  ngModelChange: (event) => {
                    if (event != 'range') {
                      this.setService.setDatas[this.blockid][1]['datas'][0]['data'][4]['show'] = true;
                      this.setService.setDatas[this.blockid][1]['datas'][0]['data'][5]['show'] = false;
                      this.setService.setDatas[this.blockid][1]['datas'][0]['data'][6]['show'] = false;
                    }
                    else {
                      this.setService.setDatas[this.blockid][1]['datas'][0]['data'][4]['show'] = false;
                      this.setService.setDatas[this.blockid][1]['datas'][0]['data'][5]['show'] = true;
                      this.setService.setDatas[this.blockid][1]['datas'][0]['data'][6]['show'] = true;
                    }
                    //额外页脚
                    if (event == 'week') this.setService.setDatas[this.blockid][1]['datas'][0]['data'][7]['show'] = false;
                    else this.setService.setDatas[this.blockid][1]['datas'][0]['data'][7]['show'] = true;
                    //今天
                    if (event != 'date') this.setService.setDatas[this.blockid][1]['datas'][0]['data'][8]['show'] = false;
                    else this.setService.setDatas[this.blockid][1]['datas'][0]['data'][8]['show'] = true;
                    //时间
                    if (event != 'date' && event != 'range') this.setService.setDatas[this.blockid][1]['datas'][1]['data'][0]['show'] = false;
                    else this.setService.setDatas[this.blockid][1]['datas'][1]['data'][0]['show'] = true;


                    this.setService.setDatas[this.blockid][1]['datas'][0]['data'][3]['show'] = false;
                    setTimeout(() => {
                      this.setService.setDatas[this.blockid][1]['datas'][0]['data'][3]['inputs']['nzKeys'] = ['styles', 'nzFormat', this.sets.styles.nzMode];
                      this.setService.setDatas[this.blockid][1]['datas'][0]['data'][3]['show'] = true;
                    }, 10);
                  }
                }
              },
              {
                name: 'switch',
                inputs: { nzText: "可清除 : ", nzKeys: ['styles', 'nzAllowClear'], }
              },
              {
                name: 'switch',
                inputs: { nzText: "只读 : ", nzKeys: ['styles', 'nzReadOnly'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.form.get(this.nzFormGroupData.nzKey).disable();
                    else
                      this.form.get(this.nzFormGroupData.nzKey).enable();
                  }
                }
              },
              {
                name: 'switch',
                inputs: { nzText: "显示必填* : ", nzKeys: ['styles', 'nzRequired'], nzPopContent: ['仅影响样式'] }
              },
              {
                name: 'input', show: true,
                inputs: { nzText: "格式 : ", nzKeys: ['styles', 'nzFormat', this.sets.styles.nzMode] }
              },
              {
                name: 'input', show: this.sets.styles.nzMode != 'range',
                inputs: { nzText: "提示文字 : ", nzKeys: ['styles', 'nzPlaceHolder'] }
              },
              {
                name: 'input', show: this.sets.styles.nzMode == 'range',
                inputs: { nzText: "提示文字1 : ", nzKeys: ['styles', 'nzPlaceHolders', 0] }
              },
              {
                name: 'input', show: this.sets.styles.nzMode == 'range',
                inputs: { nzText: "提示文字2 : ", nzKeys: ['styles', 'nzPlaceHolders', 1] }
              },
              {
                name: 'input', show: this.sets.styles.nzMode != 'week',
                inputs: { nzText: "额外页脚 : ", nzKeys: ['styles', 'nzRenderExtraFooter'] }
              },
              {
                name: 'switch', show: this.sets.styles.nzMode != 'date',
                inputs: { nzText: "显示'今天'按钮 : ", nzKeys: ['styles', 'nzShowToday'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "表单忽视 : ", nzKeys: ['styles', 'nzNoSee'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.nzFormGroupData['nzSearchDataType'] = "noSee";
                    else
                      this.nzFormGroupData['nzSearchDataType'] = "date";
                  }
                }
              },
              {
                name: 'switch',
                inputs: { nzText: "校验图标 : ", nzKeys: ['styles', 'nzHasFeedback'], nzPopContent: ['校验状态的图标'] }
              },

            ]
          },
          {
            type: 'styles',
            index: 1,
            data: [
              {
                name: 'switch', show: this.sets.styles.nzMode == 'date' || this.sets.styles.nzMode == 'range',
                inputs: { nzText: "时间选择 : ", nzKeys: ['styles', 'nzShowTime', 'nzUsed'] },
                outputs: {
                  ngModelChange: (event) => {
                    this.setService.setDatas[this.blockid][1]['datas'][1]['data'][1]['show'] = event;
                    if (!event) {
                      this.sets.styles.nzShowTime.nzObject = false;
                      this.setService.setDatas[this.blockid][1]['datas'][2]['show'] = false;

                    }
                  }
                }
              },
              {
                name: 'switch', show: this.sets.styles.nzShowTime.nzUsed == true,
                inputs: { nzText: "自定义时间 : ", nzKeys: ['styles', 'nzShowTime', 'nzObject'] },
                outputs: {
                  ngModelChange: (event) => {
                    this.setService.setDatas[this.blockid][1]['datas'][2]['show'] = event;
                    // this.setService.onReLoadbBlock(this.layoutid)
                  }
                }
              },

            ]
          },
          {
            type: 'styles',
            show: this.sets.styles.nzShowTime.nzObject == true,
            datasindex: 2,
            data: [
              {
                name: 'input',
                inputs: { nzText: "格式 : ", nzKeys: ['styles', 'nzShowTime', 'nzFormat', 'nzFormat'] }
              },
              {
                name: 'select',
                inputs: { nzText: "禁用小时 : ", nzKeys: ['datas', 'nzDisabledTime', 'nzDisabledHours'], nzData: disabledHours, nzMode: 'multiple', nzDataKeys: ['null'] }
              },
              {
                name: 'select',
                inputs: { nzText: "禁用分钟 : ", nzKeys: ['datas', 'nzDisabledTime', 'nzDisabledMinutes'], nzData: disabledMinutes, nzMode: 'multiple', nzDataKeys: ['null'] }
              },
              {
                name: 'select',
                inputs: { nzText: "禁用秒 : ", nzKeys: ['datas', 'nzDisabledTime', 'nzDisabledSeconds'], nzData: disabledMinutes, nzMode: 'multiple', nzDataKeys: ['null'] }
              },
            ]
          },
          {
            type: 'styles',
            data: [
              {
                name: 'radio',
                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
              },
              {
                name: 'nzLayout'
              },
            ]
          },
          {
            type: 'datas',
            data: [
              { name: 'nzDisabledDate' },
            ]
          }
        ]
      },
      {
        tabName: '表单',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormSet' },
            ]
          }
        ]
      }
    ]
  }
  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.nzFormGroupData['nzSearchDataType'] = "date";
        if (this.sets.styles.nzNoSee == true)
          this.nzFormGroupData['nzSearchDataType'] = "noSee";
        if (this.nzFormGroupData['nzSearchType'] == 'null')
          this.nzFormGroupData['nzSearchType'] = "=";
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }

        this.pzListening()
      }
      else {//静态
        if (typeof this.sets == "string")
          this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
      }
    }
  }
  ngOnDestroy() {
    if (!this.static) this.setService.deleteEvent(this.blockid, 'pz');
    this.setService.deleteEvent(this.blockid);
  }


  pzListening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid, 'pz');
      this.setService.pzEvents[this.blockid].subscribe(data => {
        switch (data['type']) {
          case 'changeFormValid':
            this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
            break;

          default:
            break;
        }
      }
      )
    }, 100);

  }

  disabledDate = (current: Date): boolean => {
    //可用规则
    if (this.sets.datas.nzDisabledDate.available.nzUsed) {
      if (this.sets.datas.nzDisabledDate.available.nzType == 'today') {
        let day = getDayOfYear(current);
        const yearcha = current.getFullYear() - this.today.getFullYear()
        if (yearcha == 1 || yearcha == -1) {
          if (yearcha == 1) {
            day += this.today.getFullYear() % 400 == 0 || (this.today.getFullYear() % 4 == 0 && this.today.getFullYear() % 100 != 0) ? 366 : 365
          } else {
            day -= current.getFullYear() % 400 == 0 || (current.getFullYear() % 4 == 0 && current.getFullYear() % 100 != 0) ? 366 : 365
          }
        } else if (yearcha != 0) {
          return true;
        }
        if (day - this.todayday > this.sets.datas.nzDisabledDate.available.today.after) return true;
        if (this.todayday - day > this.sets.datas.nzDisabledDate.available.today.before) return true;
      } else {
        //范围
        console.log(this.sets.datas.nzDisabledDate.available.range[0])
        let time1 = new Date(this.sets.datas.nzDisabledDate.available.range[0]);
        let time2 = new Date(this.sets.datas.nzDisabledDate.available.range[1]);
        let time = current.getTime();
        if (time < time1.getTime() || time > time2.getTime()) {
          return true;
        }
      }


    }
    //不可用规则
    if (this.sets.datas.nzDisabledDate.range.nzUsed) {
      let time = current.getTime();
      for (let index = 0; index < this.sets.datas.nzDisabledDate.range.data.length; index++) {
        const element = this.sets.datas.nzDisabledDate.range.data[index];
        let time1 = new Date(element[0]);
        let time2 = new Date(element[1]);
        if (time >= time1.getTime() && time <= time2.getTime()) {
          return true;
        }
      }
    }
    //月规则
    if (this.sets.datas.nzDisabledDate.month.nzUsed) {
      for (let index = 0; index < this.sets.datas.nzDisabledDate.month.data.length; index++) {
        const element = this.sets.datas.nzDisabledDate.month.data[index];

        if (current.getDate() == element) return true;
      }
    }
    //周规则
    if (this.sets.datas.nzDisabledDate.week.nzUsed) {
      for (let index = 0; index < this.sets.datas.nzDisabledDate.week.data.length; index++) {
        const element = this.sets.datas.nzDisabledDate.week.data[index];
        if (current.getDay() == element) return true;
      }
    }

    return false;
  };
  disabledDateTime = (): object => {
    return {
      nzDisabledHours: () => this.sets.datas.nzDisabledTime.nzDisabledHours,
      nzDisabledMinutes: () => this.sets.datas.nzDisabledTime.nzDisabledMinutes,
      nzDisabledSeconds: () => this.sets.datas.nzDisabledTime.nzDisabledSeconds
    };
  };

}
